
import { mapActions, mapGetters } from "vuex";
import { validationMixin } from "vuelidate";
import { SistemaMixin } from "@/modules/Application";
import { PessoaMixin } from "@/modules/Application";
import MetaData from "./MetaData";
import { Money } from "v-money";
import { MONEY as settingMoney } from "@/modules/Application";
export default {
  name: "app-config-boleto",
  data() {
    return {
      url: null,
      tabIndex: 0,
      configMoney: settingMoney,
      form: null,
      metaConfig: new MetaData({}),
    };
  },
  mixins: [validationMixin, SistemaMixin, PessoaMixin],
  computed: {
    ...mapGetters(["itsblocked"]),
  },
  components: {
    Money,
  },
  watch: {
    metaConfig(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.form = newValue;
      }
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getMetasByEmpresa() {
      const { data } = await this.$http.post("/metas/find");
      return data;
    },
    async getInit() {
      try {
        this.setLoading(true);
        const configMeta = await this.getMetasByEmpresa();
        this.setLoading(false);
        if (!configMeta.id_meta || configMeta == null) {
          this.metaConfig = new MetaData({});
          this.url = "/metas/create";
          return;
        }
        console.log(configMeta);
        this.metaConfig = new MetaData(configMeta);
        this.metaConfig.id_meta = configMeta.id_meta;
        this.url = "/metas/update";
      } catch {
        return;
      }
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async onSubmit() {
      const submitButton = this.$refs["submit_config_meta"];
      try {
        submitButton.classList.add("spinner", "spinner-light", "spinner-right");
        submitButton.setAttribute("disabled", "");
        await this.$http.post(this.url, this.form);
        this.$toast.success("Meta cadastrada com sucesso!");
        await this.getInit();
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      } catch (error) {
        submitButton.classList.remove(
          "spinner",
          "spinner-light",
          "spinner-right"
        );
        submitButton.removeAttribute("disabled", "");
      }
    },
  },
  async mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
    await this.getInit();
  },
};
